(function () {
  'use strict';
  var sequence = 0;
  function boot() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(function (root) {
      if (root.dataset.hadayaSizeHold) return;
      root.dataset.hadayaSizeHold = 'true';
      var queued = false;
      function refresh() {
        queued = false;
        root.querySelectorAll('select.mw-option__control').forEach(function (control) {
          var later = Array.from(control.options).find(function (option) {
            return option.textContent.trim().toLowerCase() === 'specify later';
          });
          if (!later) return;
          var note = control.nextElementSibling;
          if (!note || !note.classList.contains('hdy-size-hold')) {
            note = document.createElement('span');
            note.className = 'hdy-size-hold';
            note.id = 'HadayaSizeHold-' + (++sequence);
            note.textContent = 'Production on hold pending size.';
            note.setAttribute('role', 'status');
            control.after(note);
          }
          var active = control.value === later.value;
          note.hidden = !active;
          var descriptions = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
          descriptions = descriptions.filter(function (id) { return !/^HadayaSizeHold-/.test(id); });
          if (active) descriptions.push(note.id);
          if (descriptions.length) control.setAttribute('aria-describedby', descriptions.join(' '));
          else control.removeAttribute('aria-describedby');
        });
      }
      function schedule() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(refresh);
      }
      root.addEventListener('change', schedule);
      root.addEventListener('input', schedule);
      window.addEventListener('pageshow', schedule);
      document.addEventListener('hadaya:personalization-ready', schedule);
      new MutationObserver(schedule).observe(root, {childList:true, subtree:true});
      refresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
